// extracted by mini-css-extract-plugin
export default {"list-wrapper":"SearchList_list-wrapper__mYkOb","item":"SearchList_item__Eofwm","item-icon":"SearchList_item-icon__amDF6"};